export default "__VITE_ASSET__BdL4lnrc__"